import React, { useEffect, useState } from 'react';
import { CursorArrowRaysIcon } from '@heroicons/react/24/solid';


interface LoadingPreviewProps {
  targetFaceUrl?: string;
  delay?: number;
  position: number;
  total: number;
}

export const LoadingPreview: React.FC<LoadingPreviewProps> = ({
  targetFaceUrl,
  delay = 0,
  position,
  total
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  if (!isVisible) {
    return (
      <div className="bg-white shadow rounded-lg overflow-hidden">
        <div className="aspect-square bg-gray-100"></div>
        <div className="p-4">
          <div className="h-10 bg-gray-100 rounded-lg"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white shadow rounded-lg overflow-hidden">
      {/* Image Container Placeholder */}
      <div className="relative aspect-square bg-gray-200 overflow-hidden">
        {/* Shimmer effect */}
        <div
          className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200"
          style={{
            animation: 'shimmer 2s infinite linear',
            backgroundSize: '200% 100%'
          }}
        ></div>

        {/* Similarity Badge Placeholder */}
        <div className="absolute top-3 right-3">
          <div className="animate-pulse h-6 w-28 rounded-full bg-gray-300"></div>
        </div>

        {/* Center loading spinner */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="size-10 animate-spin rounded-full border-4 border-gray-300 border-t-indigo-500"></div>
          <p className="mt-2 text-sm font-medium text-gray-600">
            Processing {position}/{total}
          </p>
        </div>
      </div>

      {/* Button Placeholder - Matching the FaceCard button */}
      <div className="p-4">
        <button
          disabled
          className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-gray-200 text-gray-400 text-sm font-medium rounded-lg cursor-not-allowed"
        >
          <CursorArrowRaysIcon className="h-4 w-4" />
          Preview & Select
        </button>
      </div>

    </div>
  );
};